import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import {
  BACKEND_EDUCATION_LIST_KEY,
  BACKEND_EDUCATION_GOAL_API,
} from '../ChildrenInfoWorkflowConstants';
import AdvForm from '../../../CommonComponents/AdvForm';
import { inputTextChanged } from '../../../Profile/Accounts_react/AccountsUtils';
import InputAge from '../../InputAge/InputAgeView';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';

import { ageValidator } from '../ChildrenInfoWorkflowValidator';

const AgeToAttendSchoolView = ({
  workflowId,
  branch,
  clientId,
  store,
  childFirstName,
  onPostProcess,
  educationGoal,
  isEditingGoal,
}) => (
  <AdvWorkflowStep branch={branch} workflowId={workflowId} id="ChildAge">
    <Validation workflowId={workflowId} validationId={`${BACKEND_EDUCATION_LIST_KEY}.Age`} />
    <h2>What age does {childFirstName} plan to attend school?</h2>
    <AdvForm>
      <ul className="horizontal">
        <li>
          <InputAge
            maxLength={3}
            isUnder
            placeholderClassName="adv-workflows-placeholder-large"
            placeholder="Age"
            className="xsm text-center"
            value={educationGoal.Age}
            id="adv-age"
            onChange={event => {
              const saveAgeAttendingSchool = inputTextChanged(
                clientId,
                store(workflowId),
                `${BACKEND_EDUCATION_LIST_KEY}.Age`,
              );
              saveAgeAttendingSchool(event);
            }}
          />
        </li>
      </ul>
    </AdvForm>

    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={['EducationGoals']}
      validator={ageValidator(educationGoal.Age)}
      validationId={`${BACKEND_EDUCATION_LIST_KEY}.Age`}
      workflowId={workflowId}
      backendKey={BACKEND_EDUCATION_GOAL_API}
      doNotSave={!isEditingGoal}
      validatedOnClick={() => workflowAnalyticsEvents(workflowId, 'school_age_attend_completed')}
      onPostProcess={data => onPostProcess(data, educationGoal)}
    />
  </AdvWorkflowStep>
);

AgeToAttendSchoolView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store: PropTypes.func.isRequired,
  childFirstName: PropTypes.string.isRequired,
  onPostProcess: PropTypes.func.isRequired,
  educationGoal: PropTypes.shape({
    Age: PropTypes.string.isRequired,
  }).isRequired,
  isEditingGoal: PropTypes.bool.isRequired,
};

export default AgeToAttendSchoolView;
